import { render, staticRenderFns } from "./BotList.vue?vue&type=template&id=c4829340&scoped=true&"
import script from "./BotList.vue?vue&type=script&lang=js&"
export * from "./BotList.vue?vue&type=script&lang=js&"
import style0 from "./BotList.vue?vue&type=style&index=0&id=c4829340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4829340",
  null
  
)

export default component.exports